module.exports = __webpack_public_path__ + "img/i_flag_g.e6e61e70.svg";